import { defineComponent as i, openBlock as n, createElementBlock as a, normalizeClass as r, createVNode as d, createCommentVNode as o, toDisplayString as m, createElementVNode as u, renderSlot as f } from "vue";
import g from "./index60.js";
const h = {
  key: 1,
  class: "modal-description"
}, V = { class: "modal-default-content" }, w = /* @__PURE__ */ i({
  __name: "ModalContent",
  props: {
    description: {},
    alertVariant: {},
    showAlertIcon: { type: Boolean },
    contentPadding: { default: "default" }
  },
  emits: ["content-click"],
  setup(e) {
    const c = e, l = (t) => {
      switch (t) {
        case "success":
          return "check-circle";
        case "info":
          return "settings";
        case "warning":
          return "star";
        case "error":
          return "trash";
        default:
          return "settings";
      }
    }, s = (t) => `alert-${t}`;
    return (t, k) => (n(), a("main", {
      class: r(["modal-content", `modal-content--${c.contentPadding}`])
    }, [
      e.showAlertIcon && e.alertVariant ? (n(), a("div", {
        key: 0,
        class: r(["alert-icon-container", s(e.alertVariant)])
      }, [
        d(g, {
          name: l(e.alertVariant),
          size: "lg",
          color: `var(--alert-${e.alertVariant}-icon-color)`
        }, null, 8, ["name", "color"])
      ], 2)) : o("", !0),
      e.description ? (n(), a("p", h, m(e.description), 1)) : o("", !0),
      u("div", V, [
        f(t.$slots, "default")
      ])
    ], 2));
  }
});
export {
  w as default
};
